import React from 'react';

import styles from './Clock.module.scss';

interface ClockProps { }

interface ClockState {
    hour: number,
    minute: number,
    second: number
}

function dateToState(date: Date): ClockState {
    const state: ClockState = {
        hour: date.getHours(),
        minute: date.getMinutes(),
        second: date.getSeconds()
    };
    return state;
}

export default class Clock extends React.Component<ClockProps, ClockState> {
    timeout: number | undefined = undefined;

    constructor(props: ClockProps) {
        super(props);

        const now = new Date();
        this.state = dateToState(now);
    }

    componentDidMount(): void {
        this.timeout = window.setInterval(() => {
            const state = dateToState(new Date());
            this.setState(state);
        }, 200);
    }

    componentWillUnmount(): void {
        window.clearInterval(this.timeout);
    }

    render(): React.ReactNode {
        const hour = ("" + this.state.hour).padStart(2, "0");
        const minute = ("" + this.state.minute).padStart(2, "0");
        const second = ("" + this.state.second).padStart(2, "0");
        return <span className={styles.bigNumbers}>{hour}:{minute}:{second}</span>
    }

    shouldComponentUpdate(prevProps: ClockProps, prevState: ClockState) {
        return prevState.hour !== this.state.hour
            || prevState.minute !== this.state.minute
            || prevState.second !== this.state.second;
    }
}